module.exports = __webpack_public_path__ + "img/about-8.872692ac.jpg";